import React from 'react';

function BarWhatsappIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g fillRule="nonzero">
              <path
                fill="#3DB2FF"
                stroke="#3DB2FF"
                strokeWidth="2"
                d="M.304 16.696l3.642-1.001C5.252 16.515 6.83 17 8.5 17c4.705 0 8.5-3.795 8.5-8.5S13.205 0 8.5 0 0 3.795 0 8.5c0 1.67.486 3.248 1.305 4.554L.304 16.696z"
                transform="translate(-1465 -719) translate(1465 719) translate(6.5 6.5)"
              />
              <path
                fill="#FFF"
                d="M12.72 10.807c-.577 1.214-1.64 1.366-1.64 1.366-.91.182-2.064-.212-2.975-.637-1.305-.607-2.428-1.579-3.187-2.823-.334-.577-.638-1.245-.668-1.883 0 0-.121-1.062.91-1.912.092-.06.183-.091.304-.091h.456c.182 0 .364.121.425.303l.698 1.7c.06.183.03.365-.091.516l-.456.486c-.151.152-.151.364-.06.547.03.06.09.151.182.242.546.729 1.275 1.275 2.095 1.64.12.06.212.09.303.121.213.06.395-.03.516-.182l.364-.546c.091-.152.274-.243.456-.213l1.821.273c.182.03.334.182.395.365l.121.455c.061.06.061.182.03.273z"
                transform="translate(-1465 -719) translate(1465 719) translate(6.5 6.5)"
              />
            </g>
            <path
              d="M0 0H30V30H0z"
              transform="translate(-1465 -719) translate(1465 719)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BarWhatsappIcon;
